import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import HotelCardSeo from '@lt/components/components/HotelCard/index';
import HotelCardSmall from '@lt/components/components/HotelCardSmall/index';

import { hotelImagesByIdSelector } from 'src/store/hotelImages/selectors';
import Wishlist from 'src/components/Wishlist';

export const HotelCardRender = ({
  isMobile,
  isSmallCard = false,
  activateCashbackForPartner,
  wishlist,
  loadAllImages,
  isHotelCardFromMap,
  hasLabel,
  ...otherProps
}) => {
  const bonusCount = activateCashbackForPartner
    ? otherProps?.bonus_count
    : null;
  const hotelId = otherProps.hotel.id;

  const loadedImages = useSelector((state) =>
    hotelImagesByIdSelector(state, hotelId),
  );
  const defaultImages = otherProps.images.list;

  const imagesList = loadedImages?.length ? loadedImages : defaultImages;
  const onSlideChange = loadAllImages ? () => loadAllImages() : undefined;

  const hotelCardProps = {
    ...otherProps,
    bonus_count: bonusCount,
    images: {
      list: imagesList,
      count: imagesList.length,
      onSlideChange,
    },
  };

  return (
    <StyledRelativeWrapper>
      {isMobile && (
        <StyledHotelCardSmall
          {...hotelCardProps}
          isMobile
          wishlist={wishlist}
        />
      )}
      {!isMobile && isSmallCard && (
        <StyledHotelCardSmall {...hotelCardProps} isMobile={false} />
      )}
      {!isMobile && !isSmallCard && <StyledHotelCard {...hotelCardProps} />}
      <StyledWishlist
        type="hotel"
        wishlistIdentifier={hotelId}
        isWhiteHeart={isSmallCard}
        isHotelCardFromMap={isHotelCardFromMap}
        $hasLabel={hasLabel}
      />
    </StyledRelativeWrapper>
  );
};

export const HotelCard = HotelCardRender;

HotelCard.defaultProps = {
  isMobile: false,
};

HotelCard.propTypes = {
  isMobile: PropTypes.bool,
};

const StyledRelativeWrapper = styled.div`
  position: relative;
`;

const StyledWishlist = styled(Wishlist)`
  z-index: 5;
  top: ${({ $hasLabel }) => ($hasLabel ? `32px` : `8px`)};
`;

const StyledHotelCard = styled(HotelCardSeo)`
  margin-bottom: 8px;
  min-width: inherit;
  width: 100%;

  @media (min-width: 1280px) {
    max-width: 700px;
  }
`;

const StyledHotelCardSmall = styled(HotelCardSmall)`
  margin-bottom: 5px;
`;
